import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const BatteryIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-battery"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M41,3 L27,3 C25.8957153,3 25,3.89571525 25,5 L25,31 C25,32.1042847 25.8957153,33 27,33 L41,33 C42.1042847,33 43,32.1042847 43,31 L43,5 C43,3.89571525 42.1042847,3 41,3 Z M27,5 L41,5 L41,31 L27,31 L27,5 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="28 30 40 30 40 25 28 25"
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="28 24 40 24 40 19 28 19"
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="28 18 40 18 40 13 28 13"
        />
        <path
          d="M37,2 L31,2 C30.448,2 30,2.448 30,3 L30,3 C30,3.552 30.448,4 31,4 L37,4 C37.552,4 38,3.552 38,3 L38,3 C38,2.448 37.552,2 37,2"
          fill="#ffffff"
          className={styles.white}
        />
        <path
          d="M37,1 L31,1 C29.9823241,1 29.1301355,1.76406185 29.0134224,2.767948 L29.001661,2.94234651 C29,4.10428475 29.8957153,5 31,5 L37,5 C38.0176759,5 38.8698645,4.23593815 38.9865776,3.232052 L38.998339,3.05765349 C39,1.89571525 38.1042847,1 37,1 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
